import apiClient from "./client";
import type {
  LeitnerOverview,
  LeitnerReviewSession,
  LeitnerReviewResult,
  VocabCard,
  VocabCardCreate,
} from "@/types";

/**
 * Leitner box API.
 * Backend: GET /leitner/me, POST /leitner/cards, GET|POST /leitner/review
 */

export async function getLeitnerOverview(): Promise<LeitnerOverview> {
  const { data } = await apiClient.get<LeitnerOverview>("/leitner/me");
  return data;
}

export async function createLeitnerCard(
  payload: VocabCardCreate
): Promise<VocabCard> {
  const { data } = await apiClient.post<VocabCard>("/leitner/cards", payload);
  return data;
}

export async function getLeitnerReview(
  limit = 20
): Promise<LeitnerReviewSession> {
  const { data } = await apiClient.get<LeitnerReviewSession>("/leitner/review", {
    params: { limit },
  });
  return data;
}

export async function submitLeitnerReview(
  cardId: number,
  known: boolean
): Promise<LeitnerReviewResult> {
  const { data } = await apiClient.post<LeitnerReviewResult>("/leitner/review", {
    card_id: cardId,
    known,
  });
  return data;
}
